import type { ColumnDef } from "@tanstack/react-table";
import { ClockTypes } from "@repo/database";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { Booking } from "~/providers/booking-provider";
import { useUser } from "~/hooks/use-user";
import { useTempBookingStore } from "~/stores/use-booking-store";
import { DataTable } from "../miscellaneous/data-table";
import { DataTableColumnHeader } from "../miscellaneous/data-table-column-header";

export default function PendingBookings({
  bookings,
  onClose,
}: {
  bookings: Booking[];
  onClose: () => void;
}) {
  const { t } = useTranslation("common");

  const { setSelectedBooking, setBookingDialogOpen } = useTempBookingStore();
  const { user } = useUser();
  const columns: ColumnDef<Booking>[] = [
    {
      id: t("Booking.date"),
      accessorKey: "startTime",
      filterFn: "includesString",
      size: 20,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Booking.date")} />
      ),
      cell: ({ row: { original: booking } }) => {
        return (
          <p>
            {format(
              booking.startTime,
              user.clock === ClockTypes.military
                ? "dd-MM-yyyy HH:mm"
                : "MM/dd/yyyy hh:aa a",
            )}
          </p>
        );
      },
    },
    {
      id: t("Booking.Customer.name"),
      accessorKey: "fullName",
      filterFn: "includesString",
      size: 20,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Booking.Customer.name")}
        />
      ),
      cell: ({ row: { original: booking } }) => {
        return <p>{booking.fullName}</p>;
      },
    },
    {
      id: t("Booking.party_size"),
      accessorKey: "groupSize",
      filterFn: "includesString",
      size: 20,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Booking.party_size")}
        />
      ),
      cell: ({ row: { original: booking } }) => {
        return <p>{booking.groupSize}</p>;
      },
    },
    {
      id: t("Booking.created_at"),
      accessorKey: "createdAt",
      filterFn: "includesString",
      size: 20,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Booking.created_at")}
        />
      ),
      cell: ({ row: { original: booking } }) => {
        return (
          <p>
            {format(
              booking.createdAt,
              user.clock === ClockTypes.military
                ? "dd-MM-yyyy HH:mm"
                : "MM/dd/yyyy hh:aa a",
            )}
          </p>
        );
      },
    },
  ];
  return (
    <div>
      <DataTable
        onSelect={(booking) => {
          setSelectedBooking(booking);
          setBookingDialogOpen(true);
          onClose();
        }}
        defaultSorting={[{ id: t("Booking.start_time"), desc: true }]}
        columns={columns}
        data={bookings}
      />
    </div>
  );
}
